export default __webpack_public_path__ + "static/media/Mdefault.3f95247c.png";